import { render, staticRenderFns } from "./ImportHeader.vue?vue&type=template&id=2a85b3dc&scoped=true&"
import script from "./ImportHeader.vue?vue&type=script&lang=js&"
export * from "./ImportHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85b3dc",
  null
  
)

export default component.exports